import { FilterSelect, type FilterSelectProps } from "@/components/ui/filter-select";
import { LabeledFilterField } from "@/components/ui/labeled-filter-field";

export type LabeledFilterSelectProps = Omit<FilterSelectProps, "aria-label"> & {
  label: string;
  labelBgClass?: string;
};

export function LabeledFilterSelect({
  label,
  labelBgClass,
  className = "",
  id,
  ...props
}: LabeledFilterSelectProps) {
  return (
    <LabeledFilterField label={label} htmlFor={id} labelBgClass={labelBgClass}>
      <FilterSelect id={id} aria-label={label} className={className} {...props} />
    </LabeledFilterField>
  );
}
